module.exports = __webpack_public_path__ + "img/peritos_banner_ch.9867f9fe.jpg";